import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environment/environment';
import { Authentification } from './authentification';
import { ReponseApi } from './EntiteProjet';
import { extraireReponse } from './api';
import { FiltresRentabilite, RentabiliteParcDonnees } from './rentabilite-performance.types';

@Injectable({ providedIn: 'root' })
export class RentabilitePerformanceService {
  private readonly auth = inject(Authentification);
  private readonly http = inject(HttpClient);

  async getRentabiliteParc(parcId: number, filtres: FiltresRentabilite = {}): Promise<RentabiliteParcDonnees | null> {
    const url = `${environment.apiUrl}/parc/${parcId}/rentabilite`;
    let params = new HttpParams();
    if (filtres.debut) params = params.set('debut', filtres.debut);
    if (filtres.fin) params = params.set('fin', filtres.fin);
    if (filtres.installation != null) params = params.set('installation', filtres.installation);

    const res = await firstValueFrom(
      this.http.get<ReponseApi<RentabiliteParcDonnees>>(url, { ...this.auth.prepareHeaders(), params }),
    );
    return extraireReponse(res);
  }

  async exporterRentabiliteParc(parcId: number, filtres: FiltresRentabilite = {}): Promise<HttpResponse<Blob>> {
    const url = `${environment.apiUrl}/parc/${parcId}/rentabilite/export`;
    let params = new HttpParams();
    if (filtres.debut) params = params.set('debut', filtres.debut);
    if (filtres.fin) params = params.set('fin', filtres.fin);
    if (filtres.installation != null) params = params.set('installation', filtres.installation);

    return firstValueFrom(this.http.get(url, {
      ...this.auth.prepareHeaders(),
      params,
      observe: 'response',
      responseType: 'blob',
    }));
  }
}
